// extracted by mini-css-extract-plugin
export default {"section":"SettingsSidebar-module__section--F-lep","homeButton":"SettingsSidebar-module__homeButton--Gcs9C","animatedBackground":"SettingsSidebar-module__animatedBackground--vdSob"};